import { Injectable } from '@angular/core';
import type { ReportDescriptorInterface } from '@zaoblako/shared/common/dtos/report/report-descriptor.dto';
import type { WorkScheduleFindInterface } from '@zaoblako/shared/modules/security/dtos/work-schedule/work-schedule-find.dto';
import type { WorkScheduleRegistryQueryInterface } from '@zaoblako/shared/modules/security/dtos/work-schedule/work-schedule-registry-query.dto';
import type { WorkScheduleRegistryPageInterface } from '@zaoblako/shared/modules/security/dtos/work-schedule/work-schedule-registry-page.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WorkScheduleService extends BaseService {
  protected baseUrl = '/basis/security/work-schedule';

  public getReportDescriptor(): Observable<ReportDescriptorInterface> {
    return this.http.get<ReportDescriptorInterface>(this.baseUrl);
  }

  public findRegistryPage(params?: WorkScheduleRegistryQueryInterface): Observable<WorkScheduleRegistryPageInterface> {
    return this.http.get<WorkScheduleRegistryPageInterface>(`${this.baseUrl}/items`, {
      params: params ? this.objectToHttpParams(params) : {}
    });
  }

  public restoreOne(id: number): Observable<WorkScheduleFindInterface> {
    return this.http.post<WorkScheduleFindInterface>(`${this.baseUrl}/${id}/restore`, {});
  }
}
